import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, List, ListItem, ListItemText, Paper, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStore } from '../../../contexts/store'
import Prompt from "../../Elements/Prompt"
import { PodClass } from "../../../classes/Pod"
import { Op_editPod } from "../../../shared/src/types/Ops"
import { downloadableType } from "../../../shared/src/types/Miscs"
import dayjs from "dayjs"
import { ImageUploadbutton } from "../../Elements/ImageUploadButton"
import ColorSelect from "../../Elements/ColorSelect"
import { podNameMaxLength } from "../../../shared/src/validation/validationConstantsString"
import { Edit } from "@mui/icons-material"


// message from thread
const Appearance = () => {
  const { podStore, opStore, sessionStore } = useStore()
  const [showPodNamePrompt, setShowPodNamePrompt] = useState<boolean>(false)
  const [showPodDescriptionPrompt, setShowPodDescriptionPrompt] = useState<boolean>(false)

  const { t } = useTranslation()
  const session = sessionStore.session

  const pod:PodClass|null = podStore.pod
  if (!pod) return null
  if (!session) return null

  const changePodSetting = (which:'name'|'description'|'keyphrase', s:string) => {
    if (s !== null || s !== undefined) {
      const mods: {
        name?: string,
        description?: string,
        allowDownload?:downloadableType[],
        keyphrase?: string,
        tModified?: number
      } = {
        tModified: dayjs().unix()
      }
      mods[which] = s

      const op:Op_editPod = {
        op: 'editPod',
        podId: pod.podId,
        data: {
          mods,
          userId: session.user.userId,
          usergroupId: pod.getUsergroupByRole('Pod').usergroupId,
          userName: podStore.userPseudonym || '',
        }
      }

      opStore.doOp(op)
    }
  }

  const op:Op_editPod = {
    op: 'editPod',
    podId: pod.podId,
    data: {
      mods: {  },
      userId: session.user.userId,
      usergroupId: pod.getUsergroupByRole('Pod').usergroupId,
      userName: podStore.userPseudonym || '',
    }
  }

  const podImageUploadSuccess = (fileId:string) => {
    op.data.mods.podImageFileId = fileId
    console.log(op)
    opStore.doOp(op)
  }

  const podImageUploadFailure = () => {
    console.log('failure')
  }

  const setColor = (newColor:string)=> {
    const op:Op_editPod = {
      op: 'editPod',
      podId: pod.podId,
      data: {
        mods: { podColor: newColor },
        userId: session.user.userId,
        usergroupId: pod.getUsergroupByRole('Pod').usergroupId,
        userName: podStore.userPseudonym || '',
      }
    }
    opStore.doOp(op)
  }


  return <Box>
    <Card elevation={3} sx={{margin:1}}>
      <CardContent>
        <Box>
          <IconButton sx={{float:'right'}} aria-label="edit" disabled={!pod.permissions['editPod']} onClick={() => {setShowPodNamePrompt(true)}}>
            <Edit />
          </IconButton>
          <Typography sx={{fontSize:'1rem', fontWeight:'bold'}}>{t('Pod Name')}:</Typography>
        </Box>
        <Typography sx={{marginLeft:2}}>
          {pod.name}
        </Typography>
      </CardContent>
    </Card>

    <Card elevation={3} sx={{margin:1}}>
      <CardContent>
        <Box>
          <IconButton sx={{float:'right'}} aria-label="edit" disabled={!pod.permissions['editPod']} onClick={() => {setShowPodDescriptionPrompt(true)}}>
              <Edit />
            </IconButton>
          <Typography sx={{fontSize:'1rem', fontWeight:'bold'}}>{t('Pod Description')}:</Typography>
        </Box>
        <Typography sx={{marginLeft:2}}>
          {pod.description || <em style={{color:'#888'}}>{t('There currently is no description set.')}</em>}
        </Typography>
      </CardContent>
    </Card>

    <Card elevation={3} sx={{margin:1}}>
      <CardContent>
        <Box>
          <Typography sx={{fontSize:'1rem', fontWeight:'bold'}}>{t('Header Appearance')}:</Typography>
        </Box>

        <ColorSelect disabled={!pod.permissions['editPod']} color={pod.podColor ? pod.podColor : 'eee'} setColor={setColor} sx={{marginRight:1}} />
          <br />
          <ImageUploadbutton
            disabled={!pod.permissions['editPod']}
            type="podImage"
            fileId={pod.podImageFileId || null}
            success={podImageUploadSuccess}
            failure={podImageUploadFailure}
            width={1280}
            height={1280}
            variant='outlined'
          /><br />
          {
            pod.podImageFileId && <Button
              variant="outlined"
              disabled={!pod.permissions['editPod']}
              onClick={() => {
              const op:Op_editPod = {
                op: 'editPod',
                podId: pod.podId,
                data: {
                  userId: session.user.userId,
                  usergroupId: pod.getUsergroupByRole('Pod').usergroupId,
                  userName: podStore.userPseudonym || '',
                  mods: {
                    podImageFileId:null
                  }
                }
              }
              opStore.doOp(op)
            }}>{t('Remove Image')}</Button>
          }

      </CardContent>
    </Card>

    <Prompt title={t('Pod Name')} info={t('Please enter a new name for this pod') as string} open={showPodNamePrompt} handleClose={() => { setShowPodNamePrompt(false) }} onOk={(s:string) => { changePodSetting('name', s) }} type={{type:'string', minLength: 1, maxLength: podNameMaxLength}} defaultValue={pod.name} />
    <Prompt title={t('Pod Description')} info={t('Please enter a description for this pod') as string} open={showPodDescriptionPrompt} handleClose={() => { setShowPodDescriptionPrompt(false) }} onOk={(s:string) => { changePodSetting('description', s) }} type={{type:'string', maxLength:255}} defaultValue={pod.description} />
  </Box>
}

export default observer(Appearance)
